import $axios from '@/axios-instance.js'

class RegistryParticipantsServiceClass {
  baseUrl = '/api/v1/admin/registries'

  store(registryId, params) {
    return $axios.post(`${this.baseUrl}/${registryId}/participants`, params)
  }
}
export const RegistryParticipantsService = new RegistryParticipantsServiceClass()
